import { FileQuestion } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { auth } from "../api/firebaseApi";
import { HOME_PATH } from "../features/dashboard/routes";
import { useHistoryNav } from "../features/navigation/useHistoryNav";

const NotFound = () => {
  const navigate = useNavigate();
  // Back through in-app history when there is any (e.g. a broken link from
  // inside the app); a direct hit on a bad URL goes home instead.
  const { goBack } = useHistoryNav({ fallbackBackTo: HOME_PATH });

  const onClick = () => {
    if (!auth.currentUser) {
      navigate("/login", { replace: true });
      return;
    }
    goBack();
  };

  return (
    <div className="flex min-h-full w-full items-center justify-center bg-surface px-4">
      <EmptyState
        icon={FileQuestion}
        title="Page Not Found"
        description="Sorry, the page you are looking for does not exist."
        action={
          <Button variant="primary" size="sm" onClick={onClick}>
            Back
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
